const type = 'RESET_TRANSACTION';

const resetTransaction = () => ({
  type,
});

export { type };
export default resetTransaction;
